import { DynamicContentBuilder } from 'modules/dynamicContentBuilder';
import { FC, PropsWithChildren } from 'react';
import { useModalContext } from 'utils/contexts/modal';
import { useInsertAtCursor } from '../../hooks/useInsertAtCursor';
import { Modals } from '../../types';
import { DynamicContentBuilderContext } from './DynamicContentBuilderContext';

export const DynamicContentBuilderContextProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { modalState, hideModal, showModal } = useModalContext();
  const insert = useInsertAtCursor();
  const isExpanded = modalState === Modals.DynamicContentBuilder;

  const toggle = () => {
    if (isExpanded) hideModal();
    else showModal(Modals.DynamicContentBuilder);
  };

  const insertAndHideModal = (content: string) => {
    insert(content);
    hideModal();
  };

  return (
    <DynamicContentBuilderContext.Provider value={{ toggle }}>
      {isExpanded && <DynamicContentBuilder onInsert={insertAndHideModal} onClose={hideModal} />}
      {children}
    </DynamicContentBuilderContext.Provider>
  );
};
